export default "__VITE_ASSET__9e4f03f9__"